export const CommonForeignStateCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Stati Esteri',
    path: '/sistema/geografiche/estero/stato',
  },
];
